export default __webpack_public_path__ + "static/media/work__card-icon-2.01f918bb.svg";